import React from "react";

const CareerOpportunities = ({ careerOpportunities }) => {
  const fallbackImage =
    "/image-fix/career-option-icons/business-duotone-pack/business-svgrepo-com.svg"; // Add your fallback image path here

  const handleImageError = (e) => {
    e.target.src = fallbackImage;
  };

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="career-opportunities">
      <div className="bg-sddarkgray p-14">
        <div className="max-w-6xl md:px-6 mx-auto">

          <div className="flex flex-col justify-center items-center space-y-5">

            <h2 className="text-3xl font-bold text-gray-100">
              Career Opportunities
            </h2>

            <div className="h-1 w-10 bg-gray-100 mt-2 mb-4"></div>
          </div>

          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 mt-6">
              {careerOpportunities.map((opportunity, index) => (
                <div
                  key={index}
                  className="bg-sdorange rounded-lg shadow-md flex flex-col justify-center p-1"
                >

                  <div className="border border-sddarkgray w-20 h-20 mx-auto mb-4 rounded-full bg-sdbodywhite flex items-center justify-center">
                    <img
                      src={opportunity.icon || fallbackImage}
                      alt={opportunity.description}
                      className="w-14 h-14 object-contain" // Reduced size for icon and changed to object-contain
                      onError={handleImageError}
                    />
                  </div>


                  <div className="text-center">
                    <p className="text-sddarkgray font-medium text-lg mx-auto">
                      {opportunity.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerOpportunities;
